module.exports = "/img/_/_/_/assets/images/creeper/book/common//13.jpg?c00148b7a59bc8a9ceaefc9020e02048";